module.exports = __webpack_public_path__ + "static/img/zl_t.0d5375b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zl_t.png
// module id = yc5T
// module chunks = 1